document.addEventListener('DOMContentLoaded', () => {
  const productForms = document.querySelectorAll('.adm-product-form');

  const drawer = document.querySelector(
    '[data-adm-cart-drawer]'
  );

  const drawerItems = document.querySelector(
    '[data-adm-cart-items]'
  );

  const drawerCount = document.querySelector(
    '[data-adm-cart-count]'
  );

  const drawerTotal = document.querySelector(
    '[data-adm-cart-total]'
  );

  const closeButtons = document.querySelectorAll(
    '[data-adm-cart-close]'
  );

  const cartTriggers = document.querySelectorAll(
    '.adm-header__cart-link, .adm-mobile-header__cart'
  );

  const routesRoot = window.Shopify?.routes?.root || '/';

  /*
   * Icône poubelle.
   */
  const trashIcon = `
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M9 3h6l1 2h4v2H4V5h4l1-2Z"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>

      <path
        d="M6 7h12l-1 12a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 7Z"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>

      <path
        d="M10 11v6"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      ></path>

      <path
        d="M14 11v6"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      ></path>
    </svg>
  `;

  /*
   * Icône de chargement.
   */
  const loadingIcon = `
    <svg
      class="adm-cart-drawer__spinner"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        stroke-width="2"
        opacity="0.25"
      ></circle>

      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      ></path>
    </svg>
  `;

  /*
   * Sécurise les chaînes injectées dans le HTML.
   */
  const escapeHtml = (value) => {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  };

  /*
   * Formate les montants Shopify exprimés en centimes.
   */
  const formatMoney = (cents) => {
    const safeCents = Number.isFinite(Number(cents))
      ? Number(cents)
      : 0;

    return new Intl.NumberFormat('fr-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format(safeCents / 100);
  };

  /*
   * Ouvre le panier.
   */
  const openDrawer = () => {
    if (!drawer) {
      return;
    }

    drawer.classList.add('is-open');

    document.documentElement.classList.add(
      'adm-cart-drawer-open'
    );
  };

  /*
   * Ferme le panier.
   */
  const closeDrawer = () => {
    if (!drawer) {
      return;
    }

    drawer.classList.remove('is-open');

    document.documentElement.classList.remove(
      'adm-cart-drawer-open'
    );
  };

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  /*
   * Met à jour les compteurs du header.
   */
  const updateCartHeaderCount = (cart) => {
    const count = Number(cart?.item_count || 0);

    const countText = document.querySelector(
      '.cart-count-bubble span[aria-hidden="true"]'
    );

    const countHiddenText = document.querySelector(
      '.cart-count-bubble .visually-hidden'
    );

    const countBubble = document.querySelector(
      '.cart-count-bubble'
    );

    const countBubbleWrapper = document.querySelector(
      'cart-count-bubble'
    );

    if (countBubbleWrapper) {
      countBubbleWrapper.classList.toggle(
        'hidden',
        count === 0
      );
    }

    if (countBubble) {
      countBubble.classList.toggle(
        'hidden',
        count === 0
      );
    }

    if (countText) {
      countText.textContent = String(count);
    }

    if (countHiddenText) {
      countHiddenText.textContent =
        `${count} article${count > 1 ? 's' : ''}`;
    }

    const admCartLinks = document.querySelectorAll(
      '.adm-header__cart-link, .adm-mobile-header__cart'
    );

    admCartLinks.forEach((cartLink) => {
      let badge = cartLink.querySelector(
        '.adm-header__cart-count'
      );

      if (count <= 0) {
        badge?.remove();
        return;
      }

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'adm-header__cart-count';

        cartLink.appendChild(badge);
      }

      badge.textContent = String(count);
    });
  };

  /*
   * Affiche le contenu du panier.
   *
   * Organisation :
   *
   * Titre produit                    Total ligne
   * Variante
   * Prix/unité     [− quantité +]      Poubelle
   */
  const renderCart = (cart) => {
    if (!drawerItems || !drawerCount || !drawerTotal) {
      return;
    }

    const itemCount = Number(cart?.item_count || 0);

    drawerCount.textContent =
      `${itemCount} article${itemCount > 1 ? 's' : ''}`;

    drawerTotal.textContent = formatMoney(
      cart?.total_price || 0
    );

    if (!cart?.items || cart.items.length === 0) {
      drawerItems.innerHTML = `
        <p class="adm-cart-drawer__empty">
          Votre panier est vide.
        </p>
      `;

      return;
    }

    drawerItems.innerHTML = cart.items
      .map((item, index) => {
        const productTitle = escapeHtml(
          item.product_title || item.title || ''
        );

        const variantTitle = escapeHtml(
          item.variant_title || ''
        );

        const itemKey = escapeHtml(
          item.key || ''
        );

        const imageUrl = escapeHtml(
          item.image || ''
        );

        const quantity = Math.max(
          Number(item.quantity || 1),
          1
        );

        const unitPrice = Number(
          item.final_price ??
          item.price ??
          0
        );

        const lineTotal = Number(
          item.final_line_price ??
          unitPrice * quantity
        );

        const image = imageUrl
          ? `
            <img
              src="${imageUrl}"
              alt="${productTitle}"
              width="76"
              height="76"
              loading="lazy"
            >
          `
          : '';

        const variant = (
          variantTitle &&
          variantTitle !== 'Default Title'
        )
          ? `
            <span class="adm-cart-drawer__variant">
              ${variantTitle}
            </span>
          `
          : '';

        return `
          <div
            class="adm-cart-drawer__item"
            data-adm-cart-item
            data-item-key="${itemKey}"
            data-quantity="${quantity}"
          >
            <div class="adm-cart-drawer__image">
              ${image}
            </div>

            <div class="adm-cart-drawer__info">
              <div class="adm-cart-drawer__title-row">
                <strong class="adm-cart-drawer__title">
                  ${productTitle}
                </strong>

                <strong
                  class="adm-cart-drawer__line-price"
                  aria-label="Total pour cet article"
                >
                  ${formatMoney(lineTotal)}
                </strong>
              </div>

              ${variant}

              <div class="adm-cart-drawer__controls-row">
                <span class="adm-cart-drawer__unit-price">
                  ${formatMoney(unitPrice)} / unité
                </span>

                <div
                  class="adm-cart-drawer__quantity-control"
                  aria-label="Quantité de ${productTitle}"
                >
                  <button
                    type="button"
                    class="adm-cart-drawer__quantity-button"
                    data-adm-cart-quantity-change
                    data-action="decrease"
                    data-item-key="${itemKey}"
                    aria-label="Diminuer la quantité de ${productTitle}"
                    ${quantity <= 1 ? 'disabled' : ''}
                  >
                    <span aria-hidden="true">−</span>
                  </button>

                  <span
                    class="adm-cart-drawer__quantity-value"
                    aria-live="polite"
                  >
                    ${quantity}
                  </span>

                  <button
                    type="button"
                    class="adm-cart-drawer__quantity-button"
                    data-adm-cart-quantity-change
                    data-action="increase"
                    data-item-key="${itemKey}"
                    aria-label="Augmenter la quantité de ${productTitle}"
                  >
                    <span aria-hidden="true">+</span>
                  </button>
                </div>

                <button
                  type="button"
                  class="adm-cart-drawer__remove"
                  data-adm-cart-remove
                  data-item-key="${itemKey}"
                  data-line="${index + 1}"
                  aria-label="Supprimer ${productTitle} du panier"
                >
                  <span
                    class="adm-cart-drawer__remove-icon"
                    aria-hidden="true"
                  >
                    ${trashIcon}
                  </span>

                  <span class="adm-cart-drawer__remove-text">
                    Retirer
                  </span>
                </button>
              </div>
            </div>
          </div>
        `;
      })
      .join('');
  };

  /*
   * Récupère le panier Shopify.
   */
  const fetchCart = async () => {
    const response = await fetch(
      `${routesRoot}cart.js`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Impossible de récupérer le panier.'
      );
    }

    return response.json();
  };

  /*
   * Modifie la quantité d'une ligne.
   */
  const changeCartItem = async (
    itemKey,
    quantity
  ) => {
    const response = await fetch(
      `${routesRoot}cart/change.js`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity
        })
      }
    );

    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => null);

      throw new Error(
        errorData?.description ||
        errorData?.message ||
        'Impossible de modifier le panier.'
      );
    }

    return response.json();
  };

  /*
   * Recharge le panier.
   */
  const refreshCart = async () => {
    const cart = await fetchCart();

    renderCart(cart);
    updateCartHeaderCount(cart);

    return cart;
  };

  /*
   * Émet l'événement personnalisé de mise à jour.
   */
  const dispatchCartUpdated = (cart) => {
    document.dispatchEvent(
      new CustomEvent('adm:cart:updated', {
        detail: cart
      })
    );
  };

  /*
   * Bloque les boutons pendant une requête.
   */
  const setCartItemLoading = (
    itemElement,
    isLoading
  ) => {
    if (!itemElement) {
      return;
    }

    itemElement.classList.toggle(
      'is-updating',
      isLoading
    );

    const quantity = Math.max(
      Number(itemElement.dataset.quantity || 1),
      1
    );

    const buttons = itemElement.querySelectorAll(
      '[data-adm-cart-remove], [data-adm-cart-quantity-change]'
    );

    buttons.forEach((button) => {
      if (isLoading) {
        button.disabled = true;
        return;
      }

      const isDecreaseButton = button.matches(
        '[data-adm-cart-quantity-change][data-action="decrease"]'
      );

      if (isDecreaseButton) {
        button.disabled = quantity <= 1;
        return;
      }

      button.disabled = false;
    });
  };

  /*
   * Actions dans le panier.
   */
  if (drawerItems) {
    drawerItems.addEventListener('click', async (event) => {
      const removeButton = event.target.closest(
        '[data-adm-cart-remove]'
      );

      const quantityButton = event.target.closest(
        '[data-adm-cart-quantity-change]'
      );

      /*
       * Suppression.
       */
      if (removeButton) {
        const itemElement = removeButton.closest(
          '[data-adm-cart-item]'
        );

        const itemKey =
          removeButton.dataset.itemKey || '';

        const line = Number.parseInt(
          removeButton.dataset.line || '',
          10
        );

        if (
          !itemKey &&
          (!Number.isInteger(line) || line < 1)
        ) {
          console.error(
            '[ADM] Article du panier invalide.'
          );

          return;
        }

        const originalContent =
          removeButton.innerHTML;

        setCartItemLoading(
          itemElement,
          true
        );

        removeButton.innerHTML = `
          <span
            class="adm-cart-drawer__remove-icon"
            aria-hidden="true"
          >
            ${loadingIcon}
          </span>

          <span class="adm-cart-drawer__remove-text">
            Suppression
          </span>
        `;

        try {
          let cart;

          if (itemKey) {
            cart = await changeCartItem(
              itemKey,
              0
            );
          } else {
            const response = await fetch(
              `${routesRoot}cart/change.js`,
              {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  line,
                  quantity: 0
                })
              }
            );

            if (!response.ok) {
              const errorData = await response
                .json()
                .catch(() => null);

              throw new Error(
                errorData?.description ||
                errorData?.message ||
                'Impossible de supprimer cet article.'
              );
            }

            cart = await response.json();
          }

          renderCart(cart);
          updateCartHeaderCount(cart);
          dispatchCartUpdated(cart);
        } catch (error) {
          console.error(
            '[ADM] Erreur lors de la suppression.',
            error
          );

          removeButton.innerHTML =
            originalContent;

          setCartItemLoading(
            itemElement,
            false
          );

          window.alert(
            error.message ||
            'Impossible de supprimer cet article.'
          );
        }

        return;
      }

      /*
       * Changement de quantité.
       */
      if (quantityButton) {
        const itemElement = quantityButton.closest(
          '[data-adm-cart-item]'
        );

        if (!itemElement) {
          return;
        }

        const itemKey =
          quantityButton.dataset.itemKey ||
          itemElement.dataset.itemKey ||
          '';

        const action =
          quantityButton.dataset.action || '';

        const currentQuantity = Math.max(
          Number(itemElement.dataset.quantity || 1),
          1
        );

        let nextQuantity = currentQuantity;

        if (action === 'increase') {
          nextQuantity = currentQuantity + 1;
        }

        if (action === 'decrease') {
          nextQuantity = Math.max(
            currentQuantity - 1,
            1
          );
        }

        if (
          !itemKey ||
          nextQuantity === currentQuantity
        ) {
          return;
        }

        setCartItemLoading(
          itemElement,
          true
        );

        try {
          const cart = await changeCartItem(
            itemKey,
            nextQuantity
          );

          renderCart(cart);
          updateCartHeaderCount(cart);
          dispatchCartUpdated(cart);
        } catch (error) {
          console.error(
            '[ADM] Erreur lors du changement de quantité.',
            error
          );

          setCartItemLoading(
            itemElement,
            false
          );

          window.alert(
            error.message ||
            'Impossible de modifier la quantité.'
          );
        }
      }
    });
  }

  /*
   * Variante sélectionnée sur la fiche produit.
   */
  const getSelectedVariantInput = (form) => {
    return (
      form.querySelector('input[name="id"]:checked') ||
      form.querySelector('input[name="id"]')
    );
  };

  /*
   * Quantité sélectionnée sur la fiche produit.
   */
  const getQuantity = (form) => {
    const quantityInput = form.querySelector(
      'input[name="quantity"]'
    );

    const minimum = Math.max(
      Number.parseInt(
        quantityInput?.min || '1',
        10
      ) || 1,
      1
    );

    const quantity = Number.parseInt(
      quantityInput?.value || String(minimum),
      10
    );

    return Math.max(
      Number.isNaN(quantity)
        ? minimum
        : quantity,
      minimum
    );
  };

  /*
   * Met à jour le prix de la fiche produit.
   */
  const updateProductPriceAndButton = (
    form,
    updateUrl = false
  ) => {
    const selectedVariant =
      getSelectedVariantInput(form);

    const priceElement = form.querySelector(
      '[data-adm-product-price]'
    );

    const submitButton = form.querySelector(
      '.adm-product-button'
    );

    if (!selectedVariant) {
      return;
    }

    const unitPrice =
      Number.parseInt(
        selectedVariant.dataset.variantPrice || '0',
        10
      ) || 0;

    const quantity = getQuantity(form);

    const isAvailable =
      selectedVariant.dataset.variantAvailable !== 'false' &&
      !selectedVariant.disabled;

    if (priceElement) {
      priceElement.textContent = formatMoney(
        unitPrice * quantity
      );
    }

    if (
      submitButton &&
      !submitButton.classList.contains('is-loading')
    ) {
      const buttonIcon = submitButton.querySelector(
        '[data-adm-product-button-icon]'
      );

      const buttonLabel = submitButton.querySelector(
        '[data-adm-product-button-label]'
      );

      submitButton.disabled = !isAvailable;

      if (buttonIcon) {
        buttonIcon.hidden = !isAvailable;
      }

      if (buttonLabel) {
        buttonLabel.textContent = isAvailable
          ? 'Ajouter au panier'
          : 'Produit indisponible';
      }

      submitButton.dataset.originalContent =
        submitButton.innerHTML;
    }

    if (
      updateUrl &&
      window.history?.replaceState &&
      selectedVariant.value
    ) {
      const url = new URL(
        window.location.href
      );

      url.searchParams.set(
        'variant',
        selectedVariant.value
      );

      window.history.replaceState(
        {},
        '',
        url.toString()
      );
    }
  };

  /*
   * État temporaire du bouton d'ajout.
   */
  const showButtonState = (
    button,
    content,
    form,
    delay = 1600
  ) => {
    button.innerHTML = content;

    window.setTimeout(() => {
      button.classList.remove('is-loading');

      button.innerHTML =
        button.dataset.originalContent || '';

      updateProductPriceAndButton(form);
    }, delay);
  };

  /*
   * Ouverture depuis le header.
   */
  cartTriggers.forEach((trigger) => {
    trigger.addEventListener('click', async (event) => {
      event.preventDefault();

      try {
        await refreshCart();
        openDrawer();
      } catch (error) {
        console.error(
          '[ADM] Impossible d’ouvrir le panier.',
          error
        );

        openDrawer();
      }
    });
  });

  /*
   * Formulaires produits.
   */
  productForms.forEach((form) => {
    const submitButton = form.querySelector(
      '.adm-product-button'
    );

    const variantInputs = form.querySelectorAll(
      'input[name="id"]'
    );

    const quantityInput = form.querySelector(
      'input[name="quantity"]'
    );

    if (!submitButton) {
      return;
    }

    variantInputs.forEach((variantInput) => {
      variantInput.addEventListener('change', () => {
        updateProductPriceAndButton(
          form,
          true
        );
      });
    });

    if (quantityInput) {
      const handleQuantityChange = () => {
        const minimum = Math.max(
          Number.parseInt(
            quantityInput.min || '1',
            10
          ) || 1,
          1
        );

        const parsedValue = Number.parseInt(
          quantityInput.value || String(minimum),
          10
        );

        quantityInput.value = String(
          Math.max(
            Number.isNaN(parsedValue)
              ? minimum
              : parsedValue,
            minimum
          )
        );

        updateProductPriceAndButton(form);
      };

      quantityInput.addEventListener(
        'input',
        handleQuantityChange
      );

      quantityInput.addEventListener(
        'change',
        handleQuantityChange
      );
    }

    updateProductPriceAndButton(form);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const formData = new FormData(form);

      submitButton.disabled = true;
      submitButton.classList.add('is-loading');

      submitButton.innerHTML = `
        <span>Ajout en cours...</span>
      `;

      try {
        const response = await fetch(
          `${routesRoot}cart/add.js`,
          {
            method: 'POST',
            body: formData,
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (!response.ok) {
          const errorData = await response
            .json()
            .catch(() => null);

          throw new Error(
            errorData?.description ||
            'Impossible d’ajouter le produit au panier.'
          );
        }

        const cart = await refreshCart();

        openDrawer();
        dispatchCartUpdated(cart);

        showButtonState(
          submitButton,
          '<span>Produit ajouté ✓</span>',
          form,
          1300
        );
      } catch (error) {
        console.error(
          '[ADM] Erreur lors de l’ajout.',
          error
        );

        showButtonState(
          submitButton,
          '<span>Erreur lors de l’ajout</span>',
          form,
          2200
        );
      }
    });
  });

  /*
   * Chargement initial.
   */
  refreshCart().catch((error) => {
    console.error(
      '[ADM] Impossible de charger le panier.',
      error
    );
  });
});